import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

// サーバーURL
const headers = {
  'Content-Type': 'application/json', // JSON データの送信
};

const config = { // axiosの基本設定を定義
  timeout: 30000, // リクエストがタイムアウトまでの時間（30秒）
  method: 'POST', // リクエストメソッドを指定
  url: '', // リクエストURLを後で設定
  headers, // ヘッダー設定
  data: null, // 送信するデータの初期値
  withCredentials: true, // 必要に応じて認証情報をリクエストに含める
};

export default {
  // ログイン処理を行うメソッド
  login: async (authInfo) => {
    // エンドポイント設定
    config.url = dev + "/api/login" // /login URLを追加
    config.method = "POST";
    config.data = {
      username: authInfo.username,
      password: authInfo.password
    };
    try {
      const res = await axios.request(config);
      const responseAuthInfo = res.data.authInfo;
      if (responseAuthInfo) {
        // authInfoをlocalStorageに保存
        localStorage.setItem('authInfo', JSON.stringify(responseAuthInfo));
        localStorage.setItem('authUserId', responseAuthInfo.auth_user_Id);
        localStorage.setItem('sessionKey', responseAuthInfo.session_Key);
        const authInfo = JSON.parse(localStorage.getItem('authInfo'));
        const staffName = authInfo ? authInfo.auth_user_last_name : "";
        const fullName = authInfo ? authInfo.auth_user_last_name + authInfo.auth_user_first_name : "";
        localStorage.setItem('staffName', staffName);
        localStorage.setItem('fullName', fullName);
        router.push("/home")
      }
      return res.data;
    } catch (err) {
      console.error("ログイン失敗:", err);
      // エラーメッセージ処理
      throw err;
    }
  },
  logout : (authUserId, sessionKey) => {
    config.url = dev + "/api/logout"
    config.method = "post";
    config.data = {
        authUserId,
        sessionKey,
    };
    return axios.request(config)
      .then(res => { return res })
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.msg; // 認証エラー
            router.push('/login'); // ログインページにリダイレクト
          } else {
            ErrMsg = err.response.data.msg; // その他のエラー
          }
        } else {
          ErrMsg = err.message; // その他のエラー
        }
        return ErrMsg;
      });
  }
};
